const helloAldar=" | Hello Aldar"
const liveAldarApp=". Live Aldar "
const aldarInternationalNumber=" +971 2 672 5327\u200Eأو\u200E 800 -ALDAR(25327) : "
export default {
    "login_button_text": "تسجيل الدخول",
    "register_button_text": "سجل الآن",
    "footerText": "مساعدكم الافتراضي المتاح على مدار"+helloAldar +" هل لديكم أي استفسارات؟ يمكنكم العثور على الإجابات من خلال",
    "footerTextSecondLine": aldarInternationalNumber+"وللتواصل معنا"+" "+"عبر الهاتف"+liveAldarApp+"الساعة للإجابة عن استفساراتكم. كما يمكنكم تقديم طلباتكم ومتابعتها في أي وقت عبر تطبيق",
    "privacy_policy": "سياسة الخصوصية"
}
